// Colours
import { emeraldGreen, terracotta, offWhite } from "Constants/ColourConstants";

export const styles = {
  mainButton: {
    borderRadius: 30,
    background: terracotta,
    minWidth: 125,
    height: "fit-content",
  },
  secondaryButton: {
    borderRadius: 30,
    background: "white",
    color: emeraldGreen,
    borderColor: emeraldGreen,
    minWidth: 125,
    height: "fit-content",
  },
  buttonsBox: {
    width: "100%",
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    ml: 8,
    gap: 2,
    px: "5%",
  },
  stickyFooter: {
    justifyContent: "space-between",
    alignItems: "flex-end",
    position: "fixed",
    left: 0,
    bottom: 0,
    width: "100%",
    background: offWhite,
    zIndex: 900,
    py: 1,
  },
};
